import { z } from "zod";

import { requiredString } from "./fields";

export const languageRowSchema = z.object({
	language: requiredString("Pick a language and a proficiency"),
	proficiency: requiredString("Pick a language and a proficiency"),
});
